export const CHAT_SOUND_PLAY = 'chat-sound-play';
export const CHAT_SOUND_DONE = 'chat-sound-done';

export const chatSoundPlay = () => {
  return { type: CHAT_SOUND_PLAY };
};

export const chatSoundDone = () => {
  return { type: CHAT_SOUND_DONE };
};
